<template>
    <div class="sg-custom-toggle sg-checkmark" :class="{ 'sg-disabled': disabled }">
        <label>
            <input v-model="state" type="checkbox" :disabled="disabled" @change="onChange" />
            <div class="sg-alternative-display">
                <div class="sg-vrm-icon_054_check-16px" />
            </div>
            <div class="sg-caption-container">
                <div class="sg-caption">
                    <slot />
                </div>
            </div>
        </label>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Component } from 'vue-property-decorator';
import ToggleMixin from '@/vue/components/shared/toggles/ToggleMixin';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-toggle-checkmark')
export default class VrmToggleCheckmark extends ToggleMixin {
    onChange(event) {
        event.preventDefault();
        this.$emit('changed', event.target.checked);
    }
}
</script>
